module.exports = __webpack_public_path__ + "img/EmptyReview.e28311e2.svg";